import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import { query } from '@/_type/vbit-api'
import store from '@/store'
import DialogObservationLog from '@/views/Project/Observation/dialogs/observationLog/observationLog.vue'
import Log from '@/views/Log/models/log'

export default class Observation extends JsonApiObject {
    static allowCompromised = false
    static minLength = 1
    static minStrength = 0

    public constructor(data: any) {
        super(data)
    }

    static async getUpdatedAt(observationId: string) {
        let res = await Vue.prototype.$vbit.get(
            'observation',
            `observations/${observationId}?fields[observation]=updatedAt&skipLinks`
        )
        return res.data.attributes.updatedAt
    }

    static async searchObservations(filters) {
        let query: query = {
            ...filters,
            include: [
                'reporter',
                'mainAttachment',
                'responsibleUser',
                'responsibleLeader',
                'relatedCompanies',
            ],
        }

        let res = await Vue.prototype.$vbit.get('observation', `observations`, query)
        let observations: any = {}
        let users: any = {}
        let attachments: any = {}
        let companies: any = {}
        res.data.data.map((item: any) => {
            observations['' + item.id] = item
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'user':
                    users[item.id] = item
                    break
                case 'attachment':
                    attachments[item.id] = item
                    break
                case 'company':
                    companies[item.id] = item
                    break
            }
        })

        store.commit('observations', { ...store.getters.observations, ...observations })
        store.commit('observationUsers', { ...store.getters.observationUsers, ...users })
        store.commit('observationAttachments', {
            ...store.getters.observationAttachments,
            ...attachments,
        })
        store.commit('observationCompanies', {
            ...store.getters.observationCompanies,
            ...companies,
        })

        return res.data.data
    }

    static async showLog(observation: Observation) {
        await JsonApiObject.openDialog(DialogObservationLog, { observation: observation })
    }

    async getLog(observationId: string, timeStamp: any) {
        let data = {
            'filter[activityLogEntityId]': observationId,
            'filter[activityLogNumber]': ['1'],
            'filter[time][lt]': timeStamp,
        }

        let res = await Log.getLog(data)

        return res
    }
}
